/* eslint-disable no-useless-computed-key */
import DownloadIcon from '@mui/icons-material/Download';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../../../components/layout/Card';
import { Flex, Grid, MarginHandler } from '../../../styledComponents';
import ButtonCom from '../../../components/button/ButtonCom';
import TransitionsModal from '../../../components/modal/Modal';
import InputControl from '../../../components/input/InputControl';
import { FormControlLabel, Checkbox, FormGroup, FormControl, FormLabel, Button, IconButton, Tooltip, LinearProgress, CircularProgress } from '@mui/material';
import { colors, fonts } from '../../../utils';
import FilledSelectOption from '../../../components/input/FilledSelectOption';
import { endPoints } from '../../../api/apiEndpoints';
import { Api } from '../../../api/api';
import { setAllPostCategories, setPostCatList } from '../../../redux/slices/posts/posts';
import { errorNotify, successNotify } from '../../../utils/helper';
import Table from '../../../components/table/Table';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useLocation } from 'react-router-dom';
import CheckboxTree from '../../../components/treeCheckbox/TreeCheckbox,js';
import Box from '@mui/material/Box';
import DeleteModal from '../../../components/deletemodal/DeleteModal';
import moment from 'moment';
import NoAccountsIcon from '@mui/icons-material/NoAccounts';

const styles = {
	categ: {
		margin: '3rem 0em 0em 3rem',
		border: "1px solid lightgrey",
		padding: "3rem"
	},
};

const PostCategories = () => {
	// const {
	//     businessUnits: businessUnitsList,
	//     departments,
	//     subDepartments,
	// } = useSelector((state) => state.lookup);
	const dispatch = useDispatch();
	const { clientId, userId, fullName } = useSelector((state) => state?.activeAccount);
	const { primaryFont } = fonts;

	const { colorWhite, colorPrimary, colorGreenGradient } = colors;

	const { postCategories } = useSelector((state) => state?.posts);

	const location = useLocation();
	const [postStatus, setPostStatus] = useState('');
	const [formData, setFormData] = useState({
		image: '',
		name: '',
	});
	const [openDeleteModal, setOpenDeleteModal] = useState(false);

	const [isLoadingImg, setIsLoadingImg] = useState(false);
	const [openModal, setOpenModal] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [isEditing, setIsEditing] = useState(false);
	const [isLoadingModal, setIsLoadingModal] = useState(false);
	const [currentParams, setCurrentParams] = useState({
		limit: 10,
		page: 1,
		totalPages: 0,
		totalRecords: 0,
	});


	const handleChange = (e) => {
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};
	let sendId = location.pathname === "/corporate-governance-library/legal-and-regulatory/categories" ? 1 : 2;

	const handleSubmit = async () => {
		setIsLoadingModal(true)
		const data = {
			...formData,
			category_nav_id: sendId
		};
		if (isEditing) {

			try {

				if (formData.name) {
					await Api.post(endPoints?.posts?.updateCat, data, {
						headers: {
							'xt-user-token': null
						}
					})
						.then((response) => {
							successNotify("Category Updated Successfully");
							handleCloseModal();
							getCategories();
							setIsLoadingModal(false)
						})
						.catch((error) => {
							// if (error?.response?.status === 400) {
							// 	errorNotify(error?.response?.data);
							// 	setDisabledBtn(false);
							// }
							// setErrMsg(error?.response?.data?.message || errorMsg);
						});

				} else {
					errorNotify('Please Fill All Fields');

				}
			} catch (err) {
				// setErrMsg('Login Failed');
				// setDisabledBtn(false);
			}

		} else {

			try {

				if (formData.name) {
					await Api.post(endPoints?.posts?.createCat, data, {
						headers: {
							'xt-user-token': null
						}
					})
						.then((response) => {
							successNotify("Category Added Successfully");
							handleCloseModal();
							getCategories();
							setIsLoadingModal(false)
						})
						.catch((error) => {
							// if (error?.response?.status === 400) {
							// 	errorNotify(error?.response?.data);
							// 	setDisabledBtn(false);
							// }
							// setErrMsg(error?.response?.data?.message || errorMsg);
						});

				} else {
					errorNotify('Please Fill All Fields');

				}
			} catch (err) {
				// setErrMsg('Login Failed');
				// setDisabledBtn(false);
			}
		}

	};


	const getCategories = async (limit, page) => {
		setIsLoading(true)
		try {

			await Api.post(endPoints?.posts?.getCategories, {

				"category_nav_id": sendId,
				"limit": limit || 10,
				"page": page || 1


			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					dispatch(
						setAllPostCategories(
							response?.data?.data?.postCategories?.post_categories?.map((d, index) => ({
								index: index + 1,
								id: d?.id,
								name: d?.name,
								description: d?.description,
								image: d?.image,
								category_nav_id: d?.category_nav_id,
								dt: d?.dt,
								checked: false,
							})
							),
						),
					);
					const { page, limit, totalPages, totalRecords } = response?.data?.data?.postCategories?.pagination;
					setCurrentParams({ page, limit, totalPages, totalRecords });
					setIsLoading(false)
				})
				.catch((error) => {
				});
		} catch (err) {
		}
	};

	useEffect(() => {
		getCategories();
	}, [location])

	const handleEditModal = (val) => {
		setOpenModal(val)
		setFormData({ name: val.name, image: val.image, id: val.id })
		setIsEditing(true)
	};

	const handleImageUpload = (event) => {
		setIsLoadingImg(true)
		if (event.target.files.length > 0) {
			let formData = new FormData();
			let file = event.target.files[0];
			let fileName = file.name.replace(/\s/g, '');
			let timestampedFileName = `${new Date().getTime()}_${fileName}`;

			formData.append('file', file, timestampedFileName);
			Api.post(endPoints?.file?.upload, formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
					'xt-user-token': null
				}
			})
				.then((response) => {
					setIsLoadingImg(false)
					setFormData((prevState) => ({
						...prevState,
						image: response.data.data.link,
					}));
					successNotify("Image Uploaded Successfully");

				})
				.catch((error) => {

				});

		}
	};

	const handleDelete = async () => {
		try {

			await Api.post(endPoints?.posts?.deleteCat, {
				id: formData.id,
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					handleCloseDeleteModal();
					successNotify("Category Deleted Successfully")
					getCategories();

				})
				.catch((error) => {

				});

		} catch (err) {
		}
	};

	const column = [
		{
			title: '#',
			field: 'id',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.id}</h4>,
		},
		{
			title: 'Name',
			field: 'name',
			width: "10%",
			render: (rowData) => <h4 className='font-face-B'>{rowData?.name}</h4>,
		},
		{
			title: 'Image',
			field: 'image',
			render: (rowData) => <img src={rowData?.image} height='60' width='60' />,
		},
		{
			title: 'Date',
			field: 'dt',
			render: (rowData) => <h4 className='font-face-R'>{moment(rowData?.dt).format("DD-MM-YYYY")}</h4>,
		},
		{
			title: 'edit',
			field: 'edit',
			filtering: false,
			render: (rowData) => (
				<Tooltip title='Edit'>
					<IconButton onClick={() => handleEditModal(rowData)} aria-label='Edit'>
						<EditIcon />
					</IconButton>
				</Tooltip>
			),
		},
		{
			title: 'delete',
			field: 'delete',
			filtering: false,
			render: (rowData) => (
				<Tooltip title='Delete'>
					<IconButton onClick={() => handleOpenDeleteModal(rowData)} aria-label='Delete'>
						<DeleteIcon />
					</IconButton>
				</Tooltip>
			),
		},
		// {
		// 	title: 'enabled',
		// 	field: 'enabled',
		// 	render: (rowData) => <h4 className='font-face-R'>{rowData?.enabled.toString()}</h4>,
		// },

	];


	const handleCloseModal = () => {
		setOpenModal(false)
		setFormData({ name: '', image: '' })
		setIsEditing(false)

	};

	const handleOpenDeleteModal = (val) => {
		setFormData({ id: val.id })
		setOpenDeleteModal(true)
	};
	const handleCloseDeleteModal = () => {
		setFormData({ name: '', image: '' })
		setOpenDeleteModal(false)
	};



	return (
		<>
			<Card margin='3rem 1.5rem' padding='3rem'>
				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>
					<ButtonCom btnTitle='Add Category' onClickHandler={() => setOpenModal(true)} />
					{/* <CheckboxTree tree={treeData} /> */}

					<TransitionsModal
						open={openModal}
						// handleOpen={handleOpenModal}
						handleClose={handleCloseModal}
						modalTitle={isEditing ? "Update Category" : 'Create Category'}
						isLoading={isLoadingModal}
					// submitHandler={leaveApprovedHandler}
					// submitDisabledBtn={leaveApprovedDis}
					>

						<Grid gtc='repeat(auto-fit, minmax(40rem, 1fr))' margin='2.5rem 0' padding='2rem'>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.name}
									onChange={handleChange}
									// inputProps={{ maxLength: 30 }}
									label='Name'
									name='name'
									required
								/>
							</MarginHandler>

							{isLoadingImg ?
								<CircularProgress sx={{ margin: "auto" }} color="success" />
								:
								<>
									<input
										accept=".jpeg, .jpg, .png"
										style={{ display: 'none' }}
										id="image-upload"
										type="file"
										onChange={(event) => handleImageUpload(event)}
									/>
									<label htmlFor="image-upload">
										<Button
											variant="contained"
											component="span"
											color='success'
											style={{ width: '99%', marginLeft: '2px', paddingLeft: '2px', fontSize: "1em" }}
										>
											Upload
										</Button>
									</label>
									{formData?.image &&
										<img height={100} style={{ margin: "auto" }} src={formData?.image} />
									}

								</>}

							<MarginHandler mt="2rem">
								<Button
									color='primary'
									variant='contained'
									onClick={handleSubmit}
									style={{
										background: colorGreenGradient,
										fontSize: '1.6rem',
										textTransform: 'none',
										padding: '0.7rem 2rem',
										color: colorWhite,
										borderRadius: '0.5rem',
										float: "right"
									}}
									disabled={!formData.image || !formData.name}
									className='font-face-R'>
									{isEditing ? "Update " : "Create "} Category
								</Button>
							</MarginHandler>

						</Grid>
					</TransitionsModal>


					<DeleteModal
						open={openDeleteModal}
						handleClose={handleCloseDeleteModal}
						handleDelete={handleDelete}
					/>
				</Flex>

				{isLoading ?
					<Box sx={{ m: '5rem' }}>
						<LinearProgress color="success" />
					</Box>
					:
					<Table
						columns={column}
						tableData={postCategories?.map((item) => ({ ...item }))}
						sorting
						// search
						// filtering
						columnsButton
						showTitle
						paginationType='normal'
						titleHeading='All Categories'
						showToolbar={true}
						pageSize={currentParams.limit}
						onChangeRowsPerPage={(event) => getCategories(parseInt(event.target.value, 10), 1)}
						totalRecords={currentParams.totalRecords}
						handlePageChange={(event, newPage) => getCategories(currentParams.limit, newPage + 1)}
						curPage={currentParams.page - 1}
					/>
				}
			</Card>
		</>
	);
};

export default PostCategories;
